module.exports = __webpack_public_path__ + "img/google-pay.5f13f49f.svg";